import { isEnd } from './end';
import isAtBeginning from './isAtBeginning';

export default ({ editor }) => {
  const isFocusAtBeginning = isAtBeginning(editor);
  const isFocusAtEnd = isEnd({ editor });

  const isInBetween = !isFocusAtBeginning && !isFocusAtEnd;

  const { selection } = editor.value;
  const offsetCurr = selection.anchor.offset;
  editor.moveForward(1);
  const offsetAfter = editor.value.selection.anchor.offset;
  editor.select(selection);

  const isFocusAtEndOfOrg =
    !editor.value.document.getNextBlock(editor.value.focusBlock.key) &&
    offsetCurr === offsetAfter;

  return {
    isFocusAtBeginning,
    isFocusAtEnd,
    isInBetween: !isFocusAtEndOfOrg && isInBetween,
    isFocusAtEndOfOrg,
  };
};
